function hasPrivilege(roles, privilege) {
  const parsed = privilege.split(".");
  let acc = roles;
  for (var i = 0; i < parsed.length; i++) {
    acc = acc.get ? acc.get(parsed[i]) : acc[parsed[i]];
    if (!acc) {
      return false;
    }
  }
  return true;
}

export default function hasPrivileges(roles, privileges, allOf = true) {
  if (Array.isArray(privileges)) {
    let granted = false;
    for (let i = 0; i < privileges.length; i++) {
      granted = hasPrivilege(roles, privileges[i]);
      if (allOf && !granted) {
        return false;
      }
      if (granted) {
        return true;
      }
    }
    return false;
  } else {
    return hasPrivilege(roles, privileges);
  }
}



// WEBPACK FOOTER //
// ./src/utils/hasPrivileges.js